<template>
  <div class="select-bank-card-popup">
    <van-popup v-model="showPopup" round position="bottom" height="520px">
      <div class="select-bank-card-popup-content">
        <div class="title">
          <div class="title-left" @click="hidePopup">
            <img src="@/assets/style/left-pupot.png" alt="" />
          </div>
          <span class="title-text">选择银行卡</span>
          <div class="add-bank-card" @click="handleAddBankCardClick">
            + 添加银行卡
          </div>
        </div>
        <div class="bank-card-list-box">
         
          <van-radio-group v-model="radio" class="radio-group">
            <div
              v-for="item in bankList"
              :key="item.bankCardId"
              class="bank-card-item"
              :class="{'active': item.id == radio}"
            >
              <BankCardList
                ref="bankCardListRef"
                :bankCard="item"
                @change="handleChange"
              />
            </div>
          </van-radio-group>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import BankCardList from "@/components/loan/bankCardList.vue";
export default {
  name: "SelectBankCardPopup",
  components: {
    BankCardList,
  },
  data() {
    return {
      showPopup: false,
      radio:  "",
    };
  },
  async mounted() {},
  methods: {
    handleChange(item) {
      this.radio = item.id;
      this.hidePopup();
    },
    handleAddBankCardClick() {
      this.$store.commit("setBankCardBindingFlag", '1');
      this.hidePopup();
      setTimeout(() => {
        this.$router.push({
          name: "bankCardBinding",
        });
      }, 300);
    },
    init() {
      this.showPopup = true;
      this.radio = this.$store.state.bankInfo?.id || "";
      //借款页本单新增银行卡后选中新卡（不会修改默认卡）
      if(this.$store.state.receivedBank.id){
        this.radio = this.$store.state.receivedBank.id;
      }
    },
    hidePopup() {
      this.showPopup = false;
    },
  },
  computed: {
    bankList() {
      return this.$store.getters.bankList;
    },
    bankInfo() {
      return this.$store.getters.bankInfo;
    },
  },
};
</script>

<style scoped lang="scss">
.select-bank-card-popup {
  .select-bank-card-popup-content {
    padding: 16px;
    min-height: 520px;
    overflow: auto;
    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 18px;
      color: #333333;
      position: relative;
      height: 40px;
      .title-left {
        display: flex;
        align-items: center;
        width: 50px;
        position: absolute;
        left: 0;
        display: flex;
        align-items: center;
        img {
          height: 16px;
        }
      }
      .title-text {
        flex: 1;
        text-align: center;
      }
      .add-bank-card {
        position: absolute;
        right: 0;
        font-size: 13px;
        color: #1d70f7;
        height: 30px;
        border-radius: 44px;
        border: 1px solid #1d70f7;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0px 6px;
      }
    }
  }
}
.bank-card-list-box{
  max-height: 480px;
  overflow: auto;
}
.bank-card-item{
  margin-top: 16px;
}
.active{
  border: 2px solid #1d70f7;
  border-radius: 12px;
}
</style>
